import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';
import { UnifiedAccServiceComponent } from './UnifiedAccServiceComponent';
export const UnifiedAccReconnectionConfig = {
  serviceComponent: UnifiedAccServiceComponent,
  statusesForDisplaying: [AppConnectionStatuses.DISCONNECTED, AppConnectionStatuses.CONNECTION_LOST, AppConnectionStatuses.UPDATE_AVAILABLE, AppConnectionStatuses.UPGRADE_AVAILABLE]
};